import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box, TextField, Button, Typography, Link, Grid, Snackbar, Alert, useTheme } from "@mui/material"
import LoginError from "../../../components/LoginError"
import { F_START_LOGIN } from "../../../constants/routes"
import useMutation from "../../../hooks/useMutation"

const getCustomColorSx = (theme) => ({
  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.start.main,
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: theme.palette.start.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.start.main,
    },
  },
})

const ValidateEmailCode = () => {
  const navigate = useNavigate()

  const [errorMsg, setErrorMsg] = useState("")
  const [showLoginError, setShowLoginError] = useState("none")
  const [snackbarMsg, setSnackbarMsg] = useState(null)
  const [email, setEmail] = useState("")
  const [code, setCode] = useState("")

  const theme = useTheme()

  const { mutate: verifyMutation, loading: verifyLoading } = useMutation("/auth/verify")

  useEffect(() => {
    let parsedEmail = localStorage.getItem("validateEmail")
    if (parsedEmail) {
      parsedEmail = parsedEmail.replace(/['"]+/g, "")
      setEmail(parsedEmail)
    } else {
      navigate(F_START_LOGIN)
    }
  }, [navigate, setEmail])

  const handleAuthenticate = async (event) => {
    event.preventDefault()

    try {
      const res = await verifyMutation({ email, emailCode: code })

      if (res.error || res?.email !== email) {
        setShowLoginError("inherit")
        setErrorMsg(res.message)
      } else {
        setSnackbarMsg("E-Mail bestätigt")
        localStorage.removeItem("validateEmail")
        setTimeout(() => navigate(F_START_LOGIN), 2000)
      }
    } catch (e) {
      console.log(e.message)
      setErrorMsg(e.message)
    }
  }

  return (
    <Grid container>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
      <Grid item xs={10} md={4}>
        <Box
          component="form"
          onSubmit={handleAuthenticate}
          noValidate
          sx={{
            mx: "auto",
            mt: 3,
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "start.main",
            borderRadius: "12px",
            p: 3,
            width: "100%",
          }}>
          <Typography variant="h6" sx={{ color: "black" }}>
            Bestätigungs - Code
          </Typography>
          <Typography variant="body2" sx={{ color: "black" }}>
            Wir haben einen Code an <b>{email}</b> gesendet
          </Typography>

          <Link
            variant="caption"
            sx={{
              color: "gray",
              textDecoration: "none",
            }}>
            Keinen Code bekommen? Überprüfe den Spam-Ordner!
          </Link>
          <TextField
            margin="normal"
            required
            fullWidth
            id="confirmationcode"
            name="confirmationcode"
            // autoFocus
            onChange={(e) => setCode(e.target.value)}
            variant="outlined"
            sx={{ backgroundColor: "white", height: "3.5rem", borderRadius: "0.3rem", ...getCustomColorSx(theme) }}
          />
          <Button
            type="submit"
            fullWidth
            disabled={!(code.length > 5) || verifyLoading}
            sx={{ mt: 3, color: "white", backgroundColor: "start.main", height: "3.5rem" }}>
            Bestätigen
          </Button>
          <LoginError msg={errorMsg} visible={showLoginError} />

          <Snackbar
            open={!!snackbarMsg}
            onClose={(event, reason) => {
              if (reason === "clickaway") return
              setSnackbarMsg(null)
            }}>
            <Alert onClose={() => setSnackbarMsg(null)} severity="success" sx={{ width: "100%" }}>
              {snackbarMsg}
            </Alert>
          </Snackbar>
        </Box>
      </Grid>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
    </Grid>
  )
}

export default ValidateEmailCode
